import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";
import TaxPayerApiKey from "../../models/taxpayer-api-key";
import { revokeTaxPayerApiKey } from "../../api/taxpayer-api-keys";

interface TaxPayerApiKeyDeleteModalProps {
  show: boolean;
  apiKey?: TaxPayerApiKey;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const TaxPayerApiKeyDeleteModal: React.FC<TaxPayerApiKeyDeleteModalProps> = ({
  show,
  apiKey,
  onCancel,
  onSuccess,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const message = apiKey
    ? `¿Está seguro de que quiere revocar la API Key "${apiKey.keyName}"? Esta acción no se puede deshacer.`
    : "";

  const onRevokeClick = async () => {
    if (apiKey !== undefined && apiKey.id !== undefined) {
      setSubmitting(true);
      const status = await revokeTaxPayerApiKey(apiKey.id);

      if (status.status !== SUCCESS) {
        let msg = "Ha ocurrido un error!!";
        if (status.detail !== undefined) {
          msg = status.detail;
        }
        errorAlert(msg);
      } else {
        onSuccess();
      }

      setSubmitting(false);
    }
  };

  return (
    <CModal show={show} className="modal-danger" onClosed={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>Revocar API Key</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow>
            <CCol sm="12">
              <h2>{message}</h2>
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton disabled={submitting} onClick={onRevokeClick} color="danger">
          {submitting ? (
            <Spinner
              animation="grow"
              style={{
                height: "17px",
                width: "17px",
                marginTop: "auto",
                marginBottom: "auto",
                marginRight: "10px",
              }}
            />
          ) : (
            <></>
          )}
          {submitting ? "Revocando..." : "Revocar"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default TaxPayerApiKeyDeleteModal;
